import { ApiPropertyOptional, PartialType, PickType } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { IsNumber, IsOptional, Min } from 'class-validator';
import { JobPhaseBumpDto } from './job-phase-bump.dto';
import { JobPhaseBumpUpdatableInterface } from '../interfaces/job-phase-bump-updatable.interface';

@Exclude()
export class JobPhaseBumpUpdateDto
  extends PartialType(
    PickType(JobPhaseBumpDto, [
      'date',
      'contractorId',
      'timeIn',
      'timeOut',
      'paid',
      'isApprovedHours',
      'currentCost',
      'check',
      'paidDate',
      'loggedGeo',
      'approvedGeo',
      'loggedGeoAccuracy',
      'approvedGeoAccuracy',
    ]),
  )
  implements JobPhaseBumpUpdatableInterface
{
  @ApiPropertyOptional({
    title: 'Approved Hours',
    type: 'number',
  })
  @IsNumber()
  @Min(0)
  @Expose()
  @IsOptional()
  approvedHours?: number;
}
